import {FC, useMemo, useState} from 'react'
import TestSendWebhookModal, {TestSendWebhookModalMode} from './TestSendWebhookModal'

export type WebhookTableProps = {
  username: string
  password: string
  moWebhookUrl: string
  setMoWebhookUrl: (url: string) => void
  handleUpdateMo: () => void
  handleResetMo: () => void
  dlrWebhookUrl: string
  setDlrWebhookUrl: (url: string) => void
  handleUpdateDlr: () => void
  handleResetDlr: () => void
  optOutWebhookUrl: string
  setOptOutWebhookUrl: (url: string) => void
  handleUpdateOptOut: () => void
  handleResetOptOut: () => void
}
const WebhookTable: FC<WebhookTableProps> = (props) => {
  const isValidUrl = (url: string) => {
    return !/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
      url
    )
  }

  const [showModalTest, setShowModalTest] = useState(false)
  const [testMode, setTestMode] = useState<TestSendWebhookModalMode>(TestSendWebhookModalMode.Mo)
  const [testUrl, setTestUrl] = useState('')

  // Modal pop up
  const TestModal = useMemo(
    () => (
      <TestSendWebhookModal
        username={props.username}
        password={props.password}
        show={showModalTest}
        onClose={() => setShowModalTest(false)}
        mode={testMode}
        url={testUrl}
      />
    ),
    [showModalTest, testMode, testUrl]
  )

  const handleShowTestModal = (mode: TestSendWebhookModalMode, url: string) => {
    setTestMode(mode)
    setTestUrl(url)
    setShowModalTest(true)
  }

  return (
    <div className='card mb-10'>
      {TestModal}
      <div className='card-header'>
        <div className='card-title'>
          <h3 className='fs-2'>Webhook</h3>
        </div>
        <div className='card-toolbar align-items-center'></div>
      </div>
      <div className='card-body p-0'>
        <div className='table-responsive'>
          <table
            className='table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9'
            id='kt_api_keys_table'
          >
            <thead className='fs-5 text-gray-500'>
              <tr>
                <th className='w-100px ps-9'>Type</th>
                <th className='w-275px min-w-250px px-0'>Url</th>
                <th className='w-100px'>Action</th>
              </tr>
            </thead>
            <tbody className='fs-6 fw-bold text-gray-600'>
              <tr>
                <td>Receiver</td>
                <td>
                  <input
                    data-testid='inputWebhookReceiver'
                    value={props.moWebhookUrl}
                    onChange={(e: any) => props.setMoWebhookUrl(e.target.value)}
                    className='form-control form-control-lg form-control-solid msg_tags me-3'
                    placeholder='http(s)://your-webhook-receive-url'
                  />
                </td>
                <td>
                  <button
                    data-testid='btnUpdateWebhookReceiver'
                    disabled={isValidUrl(props.moWebhookUrl)}
                    className='btn btn-sm btn-primary ms-2'
                    onClick={() => props.handleUpdateMo()}
                  >
                    Update
                  </button>
                  {props.moWebhookUrl.length > 0 && (
                    <button
                      data-testid='btnResetWebhookReceiver'
                      className='btn btn-sm btn-light-primary ms-2'
                      onClick={() => props.handleResetMo()}
                    >
                      Clear
                    </button>
                  )}
                  <button
                    data-testid='btnTestSendWebhookReceiver'
                    disabled={isValidUrl(props.moWebhookUrl)}
                    className='btn btn-sm grey-btn ms-2'
                    onClick={() =>
                      handleShowTestModal(TestSendWebhookModalMode.Mo, props.moWebhookUrl)
                    }
                  >
                    Test Send
                  </button>
                </td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <input
                    data-testid='inputWebhookStatus'
                    value={props.dlrWebhookUrl}
                    onChange={(e: any) => props.setDlrWebhookUrl(e.target.value)}
                    className='form-control form-control-lg form-control-solid msg_tags me-3'
                    placeholder='http(s)://your-webhook-status-url'
                  />
                </td>
                <td>
                  <button
                    data-testid='btnUpdateWebhookStatus'
                    disabled={isValidUrl(props.dlrWebhookUrl)}
                    className='btn btn-sm btn-primary ms-2'
                    onClick={() => props.handleUpdateDlr()}
                  >
                    Update
                  </button>
                  {props.dlrWebhookUrl.length > 0 && (
                    <button
                      data-testid='btnResetWebhookStatus'
                      className='btn btn-sm btn-light-primary ms-2'
                      onClick={() => props.handleResetDlr()}
                    >
                      Clear
                    </button>
                  )}
                  <button
                    data-testid='btnTestSendWebhookStatus'
                    disabled={isValidUrl(props.dlrWebhookUrl)}
                    className='btn btn-sm grey-btn ms-2'
                    onClick={() =>
                      handleShowTestModal(TestSendWebhookModalMode.Dlr, props.dlrWebhookUrl)
                    }
                  >
                    Test Send
                  </button>
                </td>
              </tr>
              <tr>
                <td>Opt-Out</td>
                <td>
                  <input
                    data-testid='inputWebhookOptOut'
                    value={props.optOutWebhookUrl}
                    onChange={(e: any) => props.setOptOutWebhookUrl(e.target.value)}
                    className='form-control form-control-lg form-control-solid msg_tags me-3'
                    placeholder='http(s)://your-webhook-optout-url'
                  />
                </td>
                <td>
                  <button
                    data-testid='btnUpdateWebhookOptOut'
                    disabled={isValidUrl(props.optOutWebhookUrl)}
                    className='btn btn-sm btn-primary ms-2'
                    onClick={() => props.handleUpdateOptOut()}
                  >
                    Update
                  </button>
                  {props.optOutWebhookUrl.length > 0 && (
                    <button
                      data-testid='btnResetWebhookOptOut'
                      className='btn btn-sm btn-light-primary ms-2'
                      onClick={() => props.handleResetOptOut()}
                    >
                      Clear
                    </button>
                  )}
                  <button
                    data-testid='btnTestSendWebhookOptOut'
                    disabled={isValidUrl(props.optOutWebhookUrl)}
                    className='btn btn-sm grey-btn ms-2'
                    onClick={() =>
                      handleShowTestModal(TestSendWebhookModalMode.OptOut, props.optOutWebhookUrl)
                    }
                  >
                    Test Send
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default WebhookTable
